export default __webpack_public_path__ + "static/media/MarineCollagen.11802872.jpg";